import { FanModel } from './../../../../../models/fan/fan.model';
import { DateRange } from './../../date-range/date-range.component';

export class TransactionReportModel {
   reportType: string;
   dateRange: string;
   fanList: Array<FanModel>;
   selectedFan?: FanModel;
   ctnList?: Array<number>;
   selectedDevice: string;

   constructor() {
     this.reportType = '';
     this.dateRange = '';
     this.fanList = [];
   }
}

